import { httpService } from "@/modules/common/services";

const generatePublicUrl = async (link) => {
    try {
        const params = {new_api: true, private_link: link};
        const {data} = await httpService.post('business/links/v1/links', params);
        return data.public_url
    } catch (error) {
        return {error};
    }
}

export default {generatePublicUrl};